/**
 * Opens Grow / Kbite (Hlídací pes) stock-fulfilled popup from PLP cards.
 * The app loads on collections but skips rendering widgets there
 * (showOnCollectionPage: false); we reuse its initVar API instead.
 */

/**
 * @param {() => boolean} condition
 * @param {number} [timeoutMs]
 * @returns {Promise<boolean>}
 */
function waitFor(condition, timeoutMs = 4000) {
  return new Promise((resolve) => {
    const start = Date.now();
    const tick = () => {
      if (condition()) {
        resolve(true);
        return;
      }
      if (Date.now() - start >= timeoutMs) {
        resolve(false);
        return;
      }
      requestAnimationFrame(tick);
    };
    tick();
  });
}

/**
 * @returns {any | null}
 */
function getGrowConfig() {
  return globalThis.initVar || globalThis.growConfig || null;
}

/**
 * @param {HTMLElement} button
 * @returns {Promise<void>}
 */
async function openGrowWatchdogPopup(button) {
  const initVar = getGrowConfig();
  const fallbackUrl = button.getAttribute('data-watchdog-fallback-url');

  if (!initVar?.stockWidgetClicked || !initVar?.stockWidget) {
    if (fallbackUrl) {
      globalThis.location.href = fallbackUrl;
    }
    return;
  }

  const popupId = initVar.stockWidget.popupSelector;
  if (!document.getElementById(popupId) && typeof initVar.addPopUp === 'function') {
    initVar.addPopUp(popupId, initVar.stockWidget.modalHtml);
  }

  const ready = await waitFor(
    () => Boolean(globalThis.growCampaignPopUps?.[popupId] || document.getElementById(popupId)),
    4000
  );

  if (!ready && fallbackUrl) {
    globalThis.location.href = fallbackUrl;
    return;
  }

  try {
    await initVar.stockWidgetClicked({
      target: button,
      preventDefault() {},
      stopPropagation() {},
    });
  } catch (error) {
    console.warn('[plp-watchdog] failed to open Grow popup', error);
    if (fallbackUrl) {
      globalThis.location.href = fallbackUrl;
    }
  }
}

document.addEventListener(
  'click',
  (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const button = target.closest('.plp-add-to-cart__watchdog');
    if (!(button instanceof HTMLElement)) return;

    event.preventDefault();
    event.stopPropagation();
    openGrowWatchdogPopup(button);
  },
  true
);
